import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Dialog, withStyles } from '@material-ui/core'
import BinaryImageTypeForm from "./BinaryImageTypeForm";
import * as Yup from 'yup';
import * as actions from './store/binaryImageTypeActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";
import { parseURL } from "../../sc-utilities";
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const BinaryImageTypeEdit = props => {
    const { classes, loading, activeCustomer, translations, permissions, onEditBinaryImageType, onLoadBinaryImageType, binaryImageType, onLoadBinaryImageTypeInit } = props;

    const [editData, setEditData] = useState({ loadingData: true });

    useEffect(() => {
        const fetchData = async () => {
            // load binary image type
            await onLoadBinaryImageType({ ActiveCustomerID: activeCustomer, BinaryImageTypeID: parseURL(window.location.href).binaryImageTypeID })
            setEditData({ loadingData: false });
        }
        fetchData();
        return () => {
            onLoadBinaryImageTypeInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleSubmit = async data => {
        let requestData = { ...data, ActiveCustomerID: activeCustomer, BinaryImageTypeID: parseURL(window.location.href).binaryImageTypeID }
        let result = await onEditBinaryImageType(requestData);
        if (result) {
            History.goBack();
        }
    };

    const cancelHandler = () => {
        History.goBack();
    };

    let initialValues = {
        Key: binaryImageType && binaryImageType.Key ? binaryImageType.Key : "",
        Name: binaryImageType && binaryImageType.Name ? binaryImageType.Name : ""
    };
    let formSettings = {
        Validation: {
            Key: Yup.string().required("Required"),
            Name: Yup.string().required("Required")
        },
        FormTitle: translations['edit_binary_image_type'] || 'Edit binary image type',
        ButtonSubmit: hasPermission(permissions, 'binary_image_type_save') ? {
            Title: translations["save"] || "SAVE"
        } : null,
        ButtonCancel: {
            Title: translations["cancel"] || "Cancel",
            handleCancel: cancelHandler
        }
    };

    return !editData.loadingData ? <BinaryImageTypeForm
    formSettings={formSettings}
    initialValues={initialValues}
    handleSubmit={handleSubmit}
    loading={loading}
    translations={translations}
    /> :
        <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={editData.loadingData}
            PaperProps={{
                classes: {
                    root: classes.submit
                }
            }}
        >

            <AppLogoLoading />
        </Dialog>
};

const mapStateToProps = state => {
    return {
        binaryImageType: state.exportImport.binaryImageType.loaded,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        loading: state.exportImport.binaryImageType.editing,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onLoadBinaryImageTypeInit: data => dispatch(actions.loadBinaryImageTypeInit(data)),
        onLoadBinaryImageType: data => dispatch(actions.loadBinaryImageType(data)),
        onEditBinaryImageType: data => dispatch(actions.editBinaryImageType(data)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(BinaryImageTypeEdit));
